import { BaseMessage } from './base.js';
export class ChannelJoinedMessage extends BaseMessage {
    payload;
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    get userId() {
        return this.payload.userId;
    }
    get channelId() {
        return this.payload.channelId;
    }
}
